import PropTypes from "prop-types";
import CircularProgress from "@mui/material/CircularProgress";

const AccessibleSpinner = ({ label = "Loading", size = 24, ...rest }) => (
  <CircularProgress
    component="progress"
    aria-label={label}
    size={size}
    {...rest}
  />
);

AccessibleSpinner.propTypes = {
  label: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default AccessibleSpinner;
